import * as React from "react";
import { Select, } from "uxp/components";
import { IUIPropertyDefinition } from "../common";
import { Property, PropertyContainer, PropertyContainerTitle, PropertyGroup, PropertyTitle } from "./common";

export function VerticalAlignmentProperty(widgetProps: string): IUIPropertyDefinition<string> {
    return {
        defaults: widgetProps,
        render: (props) => {
            return <>
                {
                    <PropertyContainer>
                        <PropertyContainerTitle>Box Properties</PropertyContainerTitle>
                        <PropertyGroup>
                            <Property>
                                <PropertyTitle>Vertical Alignment</PropertyTitle>
                                <Select
                                    options={[{ name: "start" }, { name: "center" }, { name: "end" }]}
                                    selected={props.uiProps}
                                    onChange={s => props.onChange(s)}
                                    labelField="name"
                                    valueField="name"
                                />
                            </Property>
                        </PropertyGroup>
                    </PropertyContainer>
                }
            </>
        }
    };
}
